import { USE_CASES_NTH_USER_ONBOARDING } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';
import {
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState/onboardingState.ts';
import { isWithinLast14Days } from '../use-cases-in-nth-user-onboarding/utils/isWithinLast14Days.ts';

export const useIsEligibleForUseCasesOnboardingHomeChanges = (): {
	loading: boolean;
	isEligible: boolean;
	error?: Error;
} => {
	const {
		data,
		loading: onboardingLoading,
		error,
	} = useGetOnboardingState([
		USE_CASES_NTH_USER_ONBOARDING.VIEWED_AT,
		USE_CASES_NTH_USER_ONBOARDING.DISMISSED_HEADER,
	]);

	const { viewedAt, headerDismissed } = deserializeState(data);

	const isWithinValidTimeWindow = isWithinLast14Days(viewedAt);

	// We only want to show useCasesInNthUserOnboarding if we are within the 14 days onboarding period
	// and the header has not already been dismissed.
	const isEligibleForUseCasesHomeChanges = isWithinValidTimeWindow && !headerDismissed && !error;

	return {
		loading: onboardingLoading,
		isEligible: isEligibleForUseCasesHomeChanges,
		error,
	};
};
